import LogicSet from './LogicSet'

export default LogicSet
